import { render, staticRenderFns } from "./navigationFooter.vue?vue&type=template&id=8b0e36a0&"
import script from "./navigationFooter.vue?vue&type=script&lang=js&"
export * from "./navigationFooter.vue?vue&type=script&lang=js&"
import style0 from "./navigationFooter.vue?vue&type=style&index=0&id=8b0e36a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports